import React, {useState, useEffect}  from "react";
import Select from "react-select";

function ReactSelect(props){
    const {questionName, name ,options, handleChange, hendleDefaultCheck, formikValues} = props
    const [selected, setSelected] = useState(null)
    const [newData, setNewData] = useState(null)
    const [firstLoad, setFirstLoad] = useState(false)

    useEffect(()=>{
        setNewData(options)
        setTimeout(()=>{
            setFirstLoad(true)
        },500)
    },[options])
    
    useEffect(()=>{
        if(!!newData?.length){
            setSelected(hendleDefaultCheck(newData))
        }
    },[formikValues, firstLoad])

    return (
        !!newData?.length && <>
            {!!questionName &&
                <h2 className="card_medicine_heading">{questionName}</h2>
            }
            <Select
                className="basic-single"
                placeholder="Others"
                classNamePrefix="select"
                menuPlacement="auto"
                name={name}
                isMulti
                isClearable={false}
                isSearchable={true}
                options={newData || []}
                value={selected}
                getOptionLabel={(option) => option.short_name || option.name}
                getOptionValue={(option) => option.id}
                onChange={(e, actionMeta) => {
                    handleChange(e, actionMeta)
                    setSelected(e);
                }}
            />
            
        </>
    )
}
export default ReactSelect 